/**
 * Parcels Details
 */

// React
import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';

// Context
import authContext from '../../authContext';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import theme from '../../theme';
import {
  Dialog,
  Typography,
  DialogActions,
  Paper,
  Grid,
  Button,
  Divider,
  CircularProgress,
  Select,
  FormControl,
  IconButton,
  MenuItem,
  DialogTitle,
  TextField,
  FormHelperText,
  FormControlLabel,
  Radio, RadioGroup,
} from '@material-ui/core';


// Icon
import Icon from '@mdi/react';
import {
  mdiStateMachine,
  mdiPostOutline,
  mdiIdCard,
  mdiPaperRollOutline,
  mdiTableEye,
  mdiPackageVariant,
  mdiAccountOutline,
  mdiArrowRight,
  mdiPhoneOutline,
  mdiCalendar,
  mdiCalendarClock,
  mdiMapMarkerOutline,
  mdiPrinter,
  mdiClose,
  mdiCheck,
  mdiPackageVariantClosed,
  mdiChevronLeft,
  mdiBarcode,
  mdiAlertCircle,
  mdiFileTableBoxMultiple,
  mdiFileTree,
  mdiInformation,
  mdiKey,
  mdiHomeCity, mdiSendCircleOutline, mdiPencilOutline,
  mdiCity,
} from '@mdi/js';

// Components
import ListOrderItems from './list';
import InventoryItemsList from './inventoryItemsList';



// Helper
import {
  formaterPhoneNumber,
  translate,
} from '../../utils/helpers';
import {
  rulesAdminChangeOrderStatus,
  rulesOrderStatus,
} from '../../utils/rulesOrderStatus';
import jMoment from 'moment-jalaali';

// Type
import { Props, Product } from './interfaces';
import Pagination from '@material-ui/lab/Pagination';
import Modal from '../../components/Modal';
import { useForm } from 'react-hook-form';
import PaginationNumber from '../../components/PaginationNum';
import { InventoryItem } from '../orderPack/interfaces';
import inventoryItemsRepository from "client-sdk/src/Repository/inventory-items-repository";
import handleError from "../../utils/handleError";
import handleNotfication from "../../utils/handleNotification";
import cancellationTasksRepository from 'client-sdk/src/Repository/cancellation-task-repository';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import Can from '../../components/Can';
import { UpdateOrderPostTrackingCode } from 'client-sdk/src/orders/orders';
import Client from 'client-sdk/src/client';
// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      marginTop: '16px',
      marginBottom: '16px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },
    allocateIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingTop: '10px',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    rtlIcon: {
      marginRight: theme.spacing(1),
      transform: 'scale(-1, 1)',
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    collapseIcon: {
      marginTop: '-36px',
      textAlign: 'center',
      position: 'relative',
      width: '100%',
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '40px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: theme.palette.secondary.main,
        border: '5px solid white',
      },
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    showCount: {
      '& .MuiSelect-icon': {
        color: '#DFA01F',
      },
    },
    card: {
      minWidth: '270px',
      display: 'flex',
      background: '#fff',
      padding: '8px 4px',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    cardItem: {
      margin: '0 4px',
      flex: 1,
    },
  })
);

const token = localStorage.getItem('token') || '';
export function Details(props: Props) {
  const history = useHistory();
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [openItemsNotFound, setOpenItemsNotFound] = useState(false as boolean);
  const [openBarcode, setOpenBarcode] = useState(false as boolean);
  const [openBarcodeSerial, setOpenBarcodeSerial] = useState(false as boolean);
  const [barcodeModalChanged, setBarcodeModalChanged] = useState(
    false as boolean
  );
  const [openPackages, setOpenPackages] = useState(false as boolean);
  const [checkBarcodeDialogClosed, setCheckBarcodeDialogClosed] = useState(
    false as boolean
  );
  const [
    openDialogForChangeOrderStatus,
    setOpenDialogForChangeOrderStatus,
  ] = useState(false as boolean);
  const [
    openDialogForItemsNotRegistered,
    setOpenDialogForItemsNotRegistered,
  ] = useState(false as boolean);
  const [openRegisterItems, setOpenRegisterItems] = useState(false as boolean);
  const [openLocatingItems, setOpenLocatingItems] = useState(false as boolean);
  const [openItemHasAlreadyLocated, setOpenItemHasAlreadyLocated] = useState(
    false as boolean
  );
  const { handleSubmit, register, watch, errors } = useForm();
  const [id, setId] = useState(-1 as number);
  const [serial, setSerial] = useState('');
  const [description, setDescription] = useState('');
  const [inventoryItems, setInventoryItems] = useState([] as any[]);
  const [barcode, setBarcode] = useState('');
  const [product, setProduct] = useState({} as Product);
  const [unit, setUnit] = useState('');
  const [filtersValues, setFiltersValues] = useState({
    page: 0,
    size: 100,
  } as any);
  const [postTrackingCode, setPostTrackingCode] = useState<null | string>(null);
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [error, setError] = useState('');
  const [inventoryItemsError, setInventoryItemsError] = useState('');
  const [
    inventoryItemsWithStatusError,
    setInventoryItemsWithStatusError,
  ] = useState('');
  const [loading, setLoading] = useState(false);
  const [inventoryItemsLoading, setInventoryItemsLoading] = useState(false);
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );
  const [
    inventoryItemsWithStatusLoading,
    setInventoryItemsWithStatusLoading,
  ] = useState(false);
  const [order, setOrder] = useState();
  const [inventoryItem, setInventoryItem] = useState([]);
  const [
    inventoryItemsWithSerialError,
    setInventoryItemsWithSerialError,
  ] = useState('');
  const [
    inventoryItemsWithSerialLoading,
    setInventoryItemsWithSerialLoading,
  ] = useState(false);
  const [inventoryItemsWithSerial, setInventoryItemsWithSerial] = useState([]);
  const [previewState, setPreviewState] = useState('CANCELLED' as Status);
  const [inventoryItemsWithStatus, setInventoryItemsWithStatus] = useState([]);
  const [inventoryItemsCount, setInventoryItemsCount] = useState(0);
  const handleCollapse = () => {
    setOpen(!open);
  };

  const handleCloseSelect = () => {
    setOpenSize(false);
  };

  const handleCloseDialogForItemsNotRegistered = () => {
    setOpenDialogForItemsNotRegistered(false);
  };

  const setOpenBarcodeFunc = (product: Product) => {
    setId(product.id);
    setOpenBarcode(true);
  };

  const handleCloseDialogForChangeOrderStatus = () => {
    setOpenDialogForChangeOrderStatus(false);
  };
  const updateOrdersStatus = async (action: any) => {
    const payload = { ...action };
    try {
      const {
        pagination,
        callback,
      } = await cancellationTasksRepository.locateCancellationTasks({
        payload,
      });
      handleNotfication('محموله با موفقیت به روز رسانی شد', 'success');
      callback && callback();
    } catch (error) {
      handleError(error.response);
    }
  };
  const handleSetOrdersStatus = async (order: string) => {
    await updateOrdersStatus({
      id: props.match.params.cancellationId,
      body: '',
      pagination: {
        ...filtersValues,
      },
      callback: () => {
        history.push('/canceled-orders');
      },
    });
    setOpenDialogForItemsNotRegistered(false);
    setOpenDialogForChangeOrderStatus(false);
  };

  const handleOpenConfirmDisable = (item: Product) => {
    setOpenRegisterItems(true);
    setId(item.id);
    setProduct(item);
  };

  const checkBarcode = async () => {
    setCheckBarcodeDialogClosed(true);
    setBarcodeModalChanged(!barcodeModalChanged);
  };
  const getInventoryItemsWithSerial = async (action: any) => {
    const payload = { ...action };
    try {
      setInventoryItemsWithSerialLoading(true);
      const {
        response,
        callback,
      } = await inventoryItemsRepository.getInventoryItemsWithSerial(
        { payload },
        payload.callback
      );
      setInventoryItemsWithSerial(response.data.content);
      if (callback) {
        callback();
      }
      if (response.data.content.length === 0)
        handleNotfication('هیچ آیتمی پیدا نشد.', 'warn');
    } catch (error) {
      setInventoryItemsWithSerialError(error.message);
      handleError(error.response);
    } finally {
      setInventoryItemsWithSerialLoading(false);
    }
  };
  const getAllInventoryItemsWithOrderItemsId = async (action: any) => {
    const payload = { ...action };
    try {
      setInventoryItemsLoading(true);
      const {
        response,
        callback,
      } = await inventoryItemsRepository.getAllInventoryItems({ payload });
      setInventoryItem(response.data.content);
      setInventoryItemsCount(response.data.totalElements);
      if (callback) {
        callback();
      }
    } catch (error) {
      setInventoryItemsError(error.message);
      handleError(error.response);
    } finally {
      setInventoryItemsLoading(false);
    }
  };

  const updateInventoryItemsStatus = async (action: any) => {
    const payload = { ...action };
    try {
      const callback = await inventoryItemsRepository.locateInventoryItemsUnitForOrder(
        {
          payload,
        }
      );
      handleNotfication('وضعیت آیتم مورد نظر با موفقیت تغییر کرد ', 'success');
      callback && callback();
    } catch (error) {
      handleError(error.response);
    }
  };
  const checkSerialFunc = ({ serial }: { serial: string }) => {
    updateInventoryItemsStatus({
      id: id !== -1 ? id : inventoryItemsWithSerial[0]?.id,
      body: { barcode: parseInt(serial) },
      ...filtersValues,
      callback: () => {
        getAllInventoryItemsWithOrderItemsId({
          ...filtersValues,
          'status.equals': undefined,
          orderId: { equals: props.match.params.id },
        });
        setOpenBarcode(false);
      },
    });
    setSerial('');
    setOpenRegisterItems(false);
  };
  const handleAllocateUserFunc = () => {
    updateInventoryItemsStatus({
      id: id !== -1 ? id : inventoryItemsWithSerial[0]?.id,
      body: { barcode: parseInt(unit) },
      ...filtersValues,
      callback: () => {
        //
      },
    });
    setOpenLocatingItems(false);
    setOpenRegisterItems(false);
  };

  const handleAllocateAllItemsUserFunc = () => {
    handleAllocateAllItemsUser();
  };
  const updateAllInventoryItemsStatus = async (action: any) => {
    const payload = { ...action };
    try {
      const callback = await inventoryItemsRepository.locateAllInventoryItemsUnitForOrder(
        { payload }
      );
      callback && callback();
    } catch (error) {
      handleError(error.response);
    }
  };
  const handleAllocateAllItemsUser = () => {
    const inventoryItemsIds = inventoryItems.map(
      (inventoryItem: any) => inventoryItem.id
    );
    updateAllInventoryItemsStatus({
      body: {
        barcode: unit,
        ids: inventoryItemsIds,
      },
      ...filtersValues,
      callback: () => {
        getAllInventoryItemsWithOrderItemsId({
          ...filtersValues,
          orderId: { equals: props.match.params.id },
        });
        setOpenLocatingItems(false);
        setOpenRegisterItems(false);
        setInventoryItems([]);
      },
    });
  };

  const getInventoryItemsWithStatus = () => {
    const findNotLocated = inventoryItem.filter(
      (el: InventoryItem) =>
        el.status !== 'LOCATED' &&
        el.status !== 'CHECKED' &&
        el.status !== 'PICKED'
    );
    if (findNotLocated?.length) {
      setOpenDialogForItemsNotRegistered(true);
      return;
    }
    setOpenDialogForChangeOrderStatus(true);
  };

  const handleCloseItemHasAlreadyLocated = () => {
    setOpenItemHasAlreadyLocated(false);
    setBarcode('');
  };
  const cleanInventoryItems = () => {
    setInventoryItemsError('');
    setInventoryItemsCount(0);
    setInventoryItems([]);
  };
  useEffect(() => {
    return () => {
      cleanInventoryItems();
    };
  }, []);

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };
  const getOrderWithId = async (id: any) => {
    const payload = { id };
    try {
      setLoading(true);
      const response = await ordersRepository.getOrderWithId({ payload });
      setOrder(response.data);
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const { id } = props.match.params;
    getOrderWithId(id);
    getAllInventoryItemsWithOrderItemsId({
      ...filtersValues,
      orderId: { equals: id },
    });
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (checkBarcodeDialogClosed) handleCloseBarcodeSerial(true);
  }, [barcodeModalChanged]);

  useEffect(() => {
    if (inventoryItemsWithSerial.length !== 0) {
      setBarcode('');
      const oldInventoryItem = inventoryItems.filter(
        item => inventoryItemsWithSerial[0].serialNumber === item.serialNumber
      );
      if (
        oldInventoryItem.length === 0 &&
        inventoryItemsWithSerial[0]?.status !== 'LOCATED'
      )
        setInventoryItems([...inventoryItems, inventoryItemsWithSerial[0]]);
      if (inventoryItemsWithSerial[0]?.status === 'LOCATED') {
        setOpenItemHasAlreadyLocated(true);
      }
    }
  }, [inventoryItemsWithSerial]);

  const handleClose = () => {
    setOpenRegisterItems(false);
    setOpenLocatingItems(false);
  };

  const handleCloseItemsNotFound = () => {
    setOpenItemsNotFound(false);
  };

  const handleBarcode = (value: string) => {
    setBarcode(value);
  };

  const removeItem = (itemDeleted: any) => {
    const newValue = inventoryItems.filter(
      (item: any) => item.id !== itemDeleted.id
    );
    setInventoryItems(newValue);
  };
  const submitPostTrackingCode = async () => {
    // @ts-ignore
    try {
      const { id } = props.match.params;
      const makeRequest = new UpdateOrderPostTrackingCode()
        .id(id)
        .data(postTrackingCode)
        .build();
      const client = new Client(token);
      await client.execute(makeRequest);
      handleNotfication('کد پیگیری پست با موفقیت ثبت شد', 'success');
      getOrderWithId(id);
    } catch (err) {
      handleNotfication(
        'تغییر کد پیگیری پست ثبت نشد دوباره تلاش کنید',
        'error'
      );
    }
  };
  const handleOpenConfirmUpdateState = (body: Status) => {
    setOpenConfirmUpdateState(true);
    setPreviewState(body);
  };
  ////////////////////////////////////////
  const handleChangeTrackingCode = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPostTrackingCode(e.target?.value!);
  };
  useEffect(() => {
    if (order?.postTrackingCode) {
      setPostTrackingCode(order?.postTrackingCode);
    }
  }, [order]);
  const handleCloseBarcode = (setRegistered: boolean) => {
    setOpenBarcode(false);
    if (setRegistered && inventoryItemsWithSerial.length !== 0) {
      setId(-1);
      setOpenRegisterItems(true);
    } else if (setRegistered && inventoryItemsWithSerial.length === 0) {
      setOpenItemsNotFound(true);
    }
  };

  const handleCloseBarcodeSerial = (setRegistered: boolean) => {
    setOpenBarcodeSerial(false);
    if (setRegistered && inventoryItemsWithSerial.length !== 0) {
      setId(-1);
      setOpenLocatingItems(true);
    } else if (setRegistered && inventoryItemsWithSerial.length === 0) {
      setOpenItemsNotFound(true);
    }
  };

  const handleChangePageNum = (pageNumber: number) => {
    setFiltersValues({ ...filtersValues, page: pageNumber });
  };

  const handleFilterStatus = (status: string, type: string) => {
    if (type === 'notEquals') {
      setFiltersValues((prevState: any) => ({
        ...prevState,
        'status.notEquals': status,
        'status.equals': undefined,
      }));
    } else if (type === 'equals') {
      setFiltersValues((prevState: any) => ({
        ...prevState,
        'status.equals': status,
        'status.notEquals': undefined,
      }));
    } else {
      setFiltersValues((prevState: any) => ({
        ...prevState,
        'status.equals': undefined,
        'status.notEquals': undefined,
      }));
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.headerBox}>
        <Typography variant="h6" component="h2">
          {`
        جزيیات سفارش 
        ${order?.id}
  

     
        `}
        </Typography>
        <span className={classes.contentlabelTitle}>{order?.id}</span>
      </div>

      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Button
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}
        >
          <Icon path={mdiArrowRight} size={1} className={classes.icon} />
          {'بازگشت'}
        </Button>

        {order?.status !== 'CANCELLED' && <Link
          to={`/orders/exit-receipts/${order?.id}`}
          target="_blank"
          style={{ textDecoration: 'none' }}
        >
          <Button
            variant="contained"
            color="secondary"
            startIcon={<Icon path={mdiPrinter} size={1} />}
          >
            {'چاپ رسید خروج'}
          </Button>
        </Link>}
      </Grid>
      <Paper elevation={3} className={classes.paper} variant="elevation" square>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiAccountOutline}
                  size={1}
                  className={classes.icon}
                />
                {'نام سفارش‌دهنده:  '}
              </span>

              <span>{order?.customerName}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiPhoneOutline}
                  size={1}
                  className={classes.rtlIcon}
                />
                {'شماره همراه سفارش‌دهنده:  '}
              </span>
              <span>{formaterPhoneNumber(order?.customerMobileNumber)}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCalendar} size={1} className={classes.icon} />
                {' تاریخ ثبت سفارش :  '}
              </span>
              <span>
                {order?.registrationDate &&
                  `${jMoment(order?.registrationDate, 'YYYY/MM/DD')
                    .locale('fa')
                    .format('jYYYY/jMM/jDD')}`}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCalendar} size={1} className={classes.icon} />
                {'تاریخ تحویل سفارش:  '}
              </span>
              <span>
                {order?.deliveryDate &&
                  `${jMoment(order?.deliveryDate, 'YYYY/MM/DD')
                    .locale('fa')
                    .format('jYYYY/jMM/jDD')}`}
              </span>
            </div>
          </Grid>
          <Divider className={classes.divider} />
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiCalendarClock}
                  size={1}
                  className={classes.icon}
                />
                {' بازه تحویل سفارش :  '}
              </span>
              <span>
                {order?.deliveryStartTime &&
                  jMoment(order?.deliveryStartTime, 'hh:mm:ss')
                    .locale('fa')
                    .format('HH:mm')}
                {' - '}
                {order?.deliveryEndTime &&
                  jMoment(order?.deliveryEndTime, 'hh:mm:ss')
                    .locale('fa')
                    .format('HH:mm')}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiStateMachine}
                  size={1}
                  className={classes.icon}
                />
                {'وضعیت تحویل :  '}
              </span>
              <Can
                role={authContext.user?.role}
                perform="orders:changeOrderStatus"
                yes={() => (
                  <FormControl style={{ width: '50%' }}>
                    <Icon
                      path={mdiPencilOutline}
                      size={1}
                      className={classes.changStatusIcon}
                    />
                    <Select
                      className={classes.changStatusBox}
                      fullWidth
                      inputProps={{
                        name: 'name',
                        id: 'uncontrolled-native',
                      }}
                      name={'status'}
                      id={order?.rubikaId}
                      value={[{}]}
                      IconComponent={() => null}
                      renderValue={() => (
                        <span className={classes.renderValue}>
                          {translate(order?.status, 'order')}
                        </span>
                      )}
                    >
                      <RadioGroup
                        className={classes.radioGroup}
                        aria-label={'status'}
                        name={'status$'}
                        value={'item'}
                        onChange={(
                          e: React.ChangeEvent<{
                            value: unknown;
                          }>
                        ) =>
                          handleOpenConfirmUpdateState(
                            `"${e.target.value}"` as Status
                          )
                        }
                      >
                        {rulesOrderStatus[order?.status]?.map(
                          (item: any, index: number) => (
                            <FormControlLabel
                              className={classes.radioGroupItem}
                              key={index}
                              checked={order?.status === item}
                              value={item}
                              disabled={
                                rulesAdminChangeOrderStatus[
                                  authContext?.user.role
                                ].indexOf(item) === -1
                              }
                              control={<Radio />}
                              label={translate(item, 'order')}
                            />
                          )
                        )}
                      </RadioGroup>
                    </Select>
                  </FormControl>
                )}
                no={() => <span>{translate(order?.status, 'order')}</span>}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiSendCircleOutline}
                  size={1}
                  className={classes.rtlIcon}
                />
                {'نوع ارسال:  '}
              </span>
              <span>{translate(order?.deliveryType)}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiKey} size={1} className={classes.icon} />
                {'کدپیگیری:  '}
              </span>
              <span>{order?.trackingCode}</span>
            </div>
          </Grid>
          <Divider className={classes.divider} />

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCity} size={1} className={classes.icon} />
                {'استان:  '}
              </span>
              <span>{order?.customerProvince}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiHomeCity} size={1} className={classes.icon} />
                {'شهر:  '}
              </span>
              <span>{order?.customerCity}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiPackageVariant}
                  size={1}
                  className={classes.icon}
                />
                {'تعداد بسته:  '}
              </span>
              <span>{order?.orderPackages?.length}</span>
            </div>
          </Grid>
          <Can
            perform="post-orders:detail"
            role={authContext.user?.role}
            yes={() => (
              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiPackageVariant}
                      size={1}
                      className={classes.icon}
                    />
                    {'مشخصات مرسوله پستی:  '}
                  </span>
                  <span>
                    <Button
                      variant="contained"
                      color="secondary"
                      startIcon={<Icon path={mdiTableEye} size={1} />}
                      onClick={() => setOpenPackages(true)}
                      disabled={!props.order?.postOrders?.length}
                    >
                      {'نمایش'}
                    </Button>
                  </span>
                </div>
              </Grid>
            )}
          />
          <Divider className={classes.divider} />

          <Grid item xs={12}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiMapMarkerOutline}
                  size={1}
                  className={classes.icon}
                />
                {'آدرس سفارش‌دهنده:  '}
              </span>
              <span>{order?.customerAddress && order?.customerAddress}</span>
            </div>
          </Grid>
          <Divider className={classes.divider} />

          <Grid item xs={12}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiPaperRollOutline}
                  size={1}
                  className={classes.icon}
                />
                {'توضیحات:  '}
              </span>
              <span>{order?.description && order?.description}</span>
            </div>
          </Grid>
          <Can
            role={authContext.user?.role}
            perform="orders-info:more-info"
            yes={() => (
              <>
                <Divider className={classes.divider} />
                <Grid item xs={12} sm={3}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiIdCard}
                        size={1}
                        className={classes.icon}
                      />
                      {' کد ملی سفارش‌دهنده:  '}
                    </span>
                    <span>{order?.customerNationalCode}</span>
                  </div>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiPostOutline}
                        size={1}
                        className={classes.icon}
                      />
                      {' کد پستی سفارش‌دهنده:  '}
                    </span>
                    <span>{order?.customerZipCode}</span>
                  </div>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiPhoneOutline}
                        size={1}
                        className={classes.icon}
                      />
                      {' شماره ثابت سفارش‌دهنده:  '}
                    </span>
                    <span dir="ltr">{order?.customerPhoneNumber}</span>
                  </div>
                </Grid>
              </>
            )}
          />
          {order?.deliveryType !== 'COURIER' && (
            <React.Fragment>
              <Divider className={classes.divider} />
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon path={mdiKey} size={1} className={classes.icon} />
                    {'کد رهگیری پست:  '}
                  </span>
                  <Can
                    role={authContext.user?.role}
                    perform="orders:post-tracking-code"
                    yes={() => (
                      <React.Fragment>
                        <TextField
                          id="outlined-basic"
                          value={postTrackingCode}
                          onChange={handleChangeTrackingCode}
                          size={'small'}
                          variant="outlined"
                        />
                        <Button
                          style={{
                            marginRight: '5px',
                          }}
                          variant="contained"
                          color="secondary"
                          onClick={submitPostTrackingCode}
                          disabled
                          size={'medium'}
                        >{`ثبت`}</Button>
                      </React.Fragment>
                    )}
                    no={() => <span>{order?.postTrackingCode}</span>}
                  />
                </div>
              </Grid>
            </React.Fragment>
          )}
        </Grid>
      </Paper>
      <Grid
        style={{ marginTop: '30px', marginBottom: '20px' }}
        container
        alignItems="center"
        justify="space-between"
      >
        <div className={classes.card}>
          <div className={classes.cardItem}>
            {filtersValues?.status}
            <Button
              fullWidth
              color="secondary"
              size="medium"
              variant={
                filtersValues?.['status.equals'] === 'LOCATED'
                  ? 'contained'
                  : undefined
              }
              onClick={() => {
                handleFilterStatus('LOCATED', 'equals');
              }}
            >
              جایگذاری شده
            </Button>
          </div>
          <div className={classes.cardItem}>
            <Button
              fullWidth
              color="secondary"
              size="medium"
              variant={
                filtersValues?.['status.notEquals'] === 'LOCATED'
                  ? 'contained'
                  : undefined
              }
              onClick={() => {
                handleFilterStatus('LOCATED', 'notEquals');
              }}
            >
              جایگذاری نشده
            </Button>
          </div>
        </div>
        <Button
          variant="contained"
          color="secondary"
          size="large"
          style={{ marginBottom: '20px' }}
          startIcon={<Icon path={mdiBarcode} size={1} />}
          onClick={() => {
            setOpenBarcodeSerial(true);
          }}
        >
          {'چک کردن بارکد'}
        </Button>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {inventoryItemsLoading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            inventoryItem && (
              <ListOrderItems
                operatorId={order?.id}
                handleOpenConfirmDisable={handleOpenConfirmDisable}
                setOpenBarcode={setOpenBarcodeFunc}
                data={inventoryItem}
              />
            )
          )}
        </Grid>
        <Grid id="showFilter" item xs={12} sm={6}>
          {inventoryItem && (
            <FormControl
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                {' '}
                تعداد نمایش در هر صفحه:
              </div>
              <Select
                open={openSize}
                onClose={handleCloseSelect}
                className={classes.showCount}
                onOpen={() => setOpenSize(true)}
                value={filtersValues.size}
                onChange={handleChangeSizePage}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </FormControl>
          )}
        </Grid>
        <Grid xs={12} sm={6} container item direction="row-reverse">
          {inventoryItem && (
            <>
              <Pagination
                count={Math.ceil(inventoryItemsCount / filtersValues.size)}
                color="secondary"
                page={filtersValues.page + 1}
                onChange={handleChangePage}
              />
              <PaginationNumber onChange={handleChangePageNum} />
            </>
          )}
        </Grid>
      </Grid>
      <Grid xs={12} style={{ marginTop: '30px' }} container justify="flex-end">
        <Button
          aria-label="register-order"
          onClick={getInventoryItemsWithStatus}
          variant="contained"
          color="secondary"
          size="large"
        >
          <span className="">{'تایید جایگذاری سفارش'}</span>
          <Icon path={mdiChevronLeft} size={1} />
        </Button>
      </Grid>
      <Dialog
        fullWidth
        open={openRegisterItems}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleClose}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.allocateIcon}>
            <Icon path={mdiCheck} size={4} color={theme.palette.green.main} />
          </div>
          <div style={{ width: '80%', marginBottom: '30px' }}>
            <Grid>
              <TextField
                fullWidth
                autoFocus
                id="unit"
                name="unit"
                label="واحد"
                value={unit}
                onChange={e => setUnit(e.target.value)}
                inputRef={register({ required: true })}
                error={errors.unit && true}
              />
            </Grid>
          </div>
          <div>
            <div>
              {` از
            تغییر وضعیت کالا با شناسه
            "${id}"
            به
             "${product.status === 'REGISTERED' ? 'جایگذاری شده' : 'تطبیق شده'}"
          مطمئن هستید؟`}
            </div>
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>

            <Grid item xs={4}>
              <Button
                onClick={handleAllocateUserFunc}
                fullWidth
                variant="contained"
                disabled={!unit}
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openDialogForChangeOrderStatus}
        onClose={handleCloseDialogForChangeOrderStatus}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseDialogForChangeOrderStatus ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseDialogForChangeOrderStatus}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.editIcon}>
            <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
          </div>
          <div className={classes.cancelTitle}>
            {` از 
            تغییر وضعیت سفارش به جایگذاری شده
          مطمئن هستید؟`}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseDialogForChangeOrderStatus}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>

            <Grid item xs={4}>
              <Button
                onClick={e => handleSetOrdersStatus(order?.id)}
                fullWidth
                variant="contained"
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        open={openItemHasAlreadyLocated}
        onClose={handleCloseItemHasAlreadyLocated}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseItemHasAlreadyLocated ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseItemHasAlreadyLocated}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.editIcon}>
            <Icon
              path={mdiInformation}
              size={4}
              color={theme.palette.blue.main}
            />
          </div>
          <div className={classes.cancelTitle}>
            {`آیتم با سریال
            "${inventoryItemsWithSerial[0]?.serialNumber}"
              قبلا جایگذاری شده است`}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1} justify="flex-end">
            <Grid item xs={4}>
              <Button
                onClick={handleCloseItemHasAlreadyLocated}
                fullWidth
                variant="contained"
                size="large"
              >
                {'بستن'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        open={openDialogForItemsNotRegistered}
        onClose={handleCloseDialogForItemsNotRegistered}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseDialogForItemsNotRegistered ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseDialogForItemsNotRegistered}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.allocateIcon}>
            <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
          </div>
          <div className={classes.cancelTitle}>
            {inventoryItemsWithStatus.length > 1 ? (
              <div>
                {`تعداد 
                "${inventoryItemsWithStatus.length}"
                آیتم از کالاها
                مانند آیتم با مشخصات 
              "${'نام کالا'} : ${inventoryItemsWithStatus[0]?.productName
                  }  - ${'شناسه کالا'} : ${inventoryItemsWithStatus[0]?.productId
                  }"
              هنوز جایگذاری داده نشده است.`}
              </div>
            ) : (
              <div>
                آیتم با شناسه
                {inventoryItem
                  ?.filter(
                    (el: InventoryItem) =>
                      el.status !== 'LOCATED' &&
                      el.status !== 'CHECKED' &&
                      el.status !== 'PICKED'
                  )
                  ?.map((el: any, i: number) => (
                    <span>
                      {i !== 0 && '-'} {el.id}{' '}
                    </span>
                  ))}
                هنوز جایگذاری داده نشده است
              </div>
            )}
            <div>
              <Grid>
                <TextField
                  fullWidth
                  id="description"
                  name="description"
                  autoFocus
                  rows={3}
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                  label="توضیحات"
                />
              </Grid>
            </div>
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseDialogForItemsNotRegistered}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'بررسی مجدد'}
              </Button>
            </Grid>

            <Grid item xs={4}>
              <Button
                onClick={e => handleSetOrdersStatus(order?.id)}
                fullWidth
                variant="contained"
                size="large"
              >
                {'ایجاد مغایرت'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openLocatingItems}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleClose}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.allocateIcon}>
            <Icon path={mdiCheck} size={4} color={theme.palette.green.main} />
          </div>
          <div style={{ width: '80%', marginBottom: '30px' }}>
            <Grid>
              <TextField
                fullWidth
                autoFocus
                id="unitItems"
                name="unitItems"
                label="واحد"
                value={unit}
                onChange={e => setUnit(e.target.value)}
                inputRef={register({ required: true })}
                error={errors.unit && true}
              />
            </Grid>
          </div>
          <div>
            {id !== -1 || inventoryItemsWithSerial.length === 0 ? (
              <div>
                {` از
            تغییر وضعیت کالا با شناسه
            "${id}"
            به
            جایگذاری شده
          مطمئن هستید؟`}
              </div>
            ) : (
              <div>
                <Grid
                  style={{ marginBottom: '15px' }}
                  container
                  alignItems="center"
                >
                  {`تعداد
            "${inventoryItems.length}"
           آیتم انتخاب شده است`}
                </Grid>
                <div className={classes.cancelTitle}>
                  {` از
            تغییر وضعیت کالاها
            به
            "${inventoryItemsWithSerial[0]?.status === 'REGISTERED'
                      ? 'جایگذاری شده'
                      : 'تطبیق شده'
                    }"
          مطمئن هستید؟`}
                </div>
              </div>
            )}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>

            <Grid item xs={4}>
              <Button
                onClick={handleAllocateAllItemsUserFunc}
                fullWidth
                variant="contained"
                size="large"
                disabled={!unit}
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openItemsNotFound}
        onClose={handleCloseItemsNotFound}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseItemsNotFound ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseItemsNotFound}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.allocateIcon}>
            <Icon path={mdiAlertCircle} size={4} color="#faa320" />
          </div>
          <div className={classes.cancelTitle}>
            {`آیتم مورد نظر با بارکد 
            " ${barcode} "
            یافت نشد.`}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container justify="flex-end">
            <Button
              autoFocus
              onClick={handleCloseItemsNotFound}
              variant="contained"
              color="secondary"
              size="large"
            >
              {'باشه'}
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
      <Modal
        maxWidth="lg"
        onClose={() => handleCloseBarcode(false)}
        open={openBarcode}
        title={
          <Grid container justify="center">
            <Icon
              path={mdiPackageVariantClosed}
              size={4}
              color={theme.palette.green.main}
            />
          </Grid>
        }
        content={
          <form onSubmit={handleSubmit(checkSerialFunc)}>
            <Grid container>
              <Grid item xs={12}>
                <p>{'سریال یونیت مورد نظر را اسکن کنید'}</p>
              </Grid>
              <Grid xs={12}>
                <div style={{ width: '100%', marginBottom: '30px' }}>
                  <TextField
                    fullWidth
                    autoFocus
                    id="serial"
                    name="serial"
                    label="سریال"
                    inputRef={register({ required: true })}
                  />
                </div>
                <FormHelperText error focused>
                  {errors.serial && 'سریال یونیت الزامی میباشد'}
                </FormHelperText>
              </Grid>
              <Grid xs={12} container justify="flex-end">
                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  type="submit"
                  disabled={watch('serial')?.length === 0}
                  startIcon={<Icon path={mdiFileTableBoxMultiple} size={1} />}
                >
                  {'جایگذاری کالا'}
                </Button>
              </Grid>
            </Grid>
          </form>
        }
      />
      <Modal
        maxWidth="lg"
        onClose={() => handleCloseBarcodeSerial(false)}
        open={openBarcodeSerial}
        title={
          <Grid container justify="center">
            <Icon
              path={mdiPackageVariantClosed}
              size={4}
              color={theme.palette.green.main}
            />
          </Grid>
        }
        content={
          <Grid container>
            <BarcodeForm
              id={props.match.params.id}
              inventoryItemsWithSerial={inventoryItemsWithSerial}
              getInventoryItemsWithSerialActionDispatch={
                getInventoryItemsWithSerial
              }
              inventoryItemsWithSerialLoading={inventoryItemsWithSerialLoading}
            />
            {inventoryItems.length !== 0 ? (
              <>
                <Grid
                  container
                  style={{
                    marginTop: '30px',
                    marginBottom: '30px',
                    maxHeight: '200px',
                    overflowY: 'scroll',
                  }}
                >
                  <InventoryItemsList
                    operatorId={order.id}
                    removeItem={(item: any) => removeItem(item)}
                    data={inventoryItems}
                  />
                </Grid>
                <Grid
                  xs={12}
                  container
                  spacing={3}
                  justify="flex-end"
                  alignItems="center"
                >
                  <div style={{ margin: '0 20px' }}>
                    <span>{'تعداد : '}</span>
                    <span>{inventoryItems.length}</span>
                  </div>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="large"
                    startIcon={<Icon path={mdiFileTree} size={1} />}
                    onClick={checkBarcode}
                  >
                    {'جایگذاری کالا ها'}
                  </Button>
                </Grid>
              </>
            ) : null}
          </Grid>
        }
      />
    </div>
  );
}

export type Inputs = {
  barcodeSerial: string;
};

function BarcodeForm(props: any) {
  const { handleSubmit, register, getValues, setValue, watch, errors } = useForm<Inputs>();

  useEffect(() => {
    if (props.inventoryItemsWithSerial.length !== 0) {
      setValue('barcodeSerial', '');
    }
  }, [props.inventoryItemsWithSerial])

  const checkBarcodeFunc = (data: any) => {
    props.getInventoryItemsWithSerialActionDispatch({
      serialNumber: { equals: data.barcodeSerial },
      orderId: { equals: props.id },
    });
  };

  return (
    <form
      style={{ width: '100%' }}
      onSubmit={handleSubmit(checkBarcodeFunc)}
    >
      <Grid container>
        <Grid xs={12}>
          <div style={{ width: '100%', marginBottom: '30px' }}>
            <TextField
              fullWidth
              autoFocus
              id="barcodeSerial"
              name="barcodeSerial"
              label="بارکد"
              InputProps={{
                readOnly: props.inventoryItemsWithSerialLoading
              }}
              inputRef={register({ required: true })}
            />
          </div>
        </Grid>
        <Grid xs={12} container justify="flex-end">
          <Button
            variant="contained"
            color="secondary"
            size="large"
            disabled={
              watch('barcodeSerial')?.length === 0 ||
              props.inventoryItemsWithSerialLoading
            }
            startIcon={<Icon path={mdiFileTableBoxMultiple} size={1} />}
            type="submit"
          >
            {'یافتن کالا'}
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}


// @ts-ignore
export default Details;
